/* eslint no-use-before-define: 0 */

import Context from "shared/util/Context";
import debounce from "just-debounce";

import {
	AD_VISIBILITY_LEEWAY,
} from "./constants.js";

// Local store
let _bidCallback = () => null;
let _inittedVisibilityManager = false;
let _visibilityBuffer = [];
let _windowTop = 0;
let _windowBottom = 0;
let _isSettingVisibility = false;

// functions
function _initVisibilityManager() {
	_setVisibility();
	window.addEventListener("resize", _onScrollSoon);
	window.addEventListener("scroll", _onScrollSoon);
}

function _onScroll() {
	if (!_isSettingVisibility) {
		_isSettingVisibility = true;
		window.requestAnimationFrame(() => {
			_isSettingVisibility = false;
			_setVisibility(true);
			_checkIfVisibleSoon();
		});
	}
}

const _onScrollSoon = debounce(_onScroll, 100);

function _setVisibility(isOnScroll) {
	const top = window.scrollY;
	const height = window.innerHeight;

	// if they're not scrolling (i.e. it's first pageload), scuttle the leeway

	// add a 100px buffer to the top of the window
	_windowTop = top - (isOnScroll ? AD_VISIBILITY_LEEWAY : 0);

	// and the same to the bottom
	_windowBottom = top + height + (isOnScroll ? AD_VISIBILITY_LEEWAY : 0);
}

function _showAdsIfVisible(ads) {
	// skip if they're ad-free
	if (Context.get("adFree")) {
		return;
	}

	// short-circuit unless this is turned on
	if (!Context.get("onlyFetchVisibleAds")) {
		_bidCallback(ads);
		return;
	}

	if (!_inittedVisibilityManager) {
		_inittedVisibilityManager = true;
		_initVisibilityManager();
	}

	_visibilityBuffer = _visibilityBuffer.concat(ads.map(_getAdVisibility).filter((ad) => ad));

	_checkIfVisible();
}

function _getAdVisibility(ad) {
	const { code } = ad;
	const el = document.getElementById(code);

	if (el) {
		const { top, height } = el.getBoundingClientRect();

		const newTop = _windowTop + top;
		const newBottom = _windowTop + top + height;

		return {
			...ad,
			top: newTop,
			bottom: newBottom,
		};
	}
	else {
		return null;
	}
}

function _checkIfVisible() {
	const visibleAds = [];
	const invisibleAds = [];

	_visibilityBuffer.forEach((ad) => {
		const { top, bottom } = ad;

		const bottomVisible = bottom >= _windowTop && _windowBottom >= bottom;
		const topVisible = top >= _windowTop && _windowBottom >= top;

		if (bottomVisible || topVisible) {
			visibleAds.push(ad);
		} else {
			invisibleAds.push(ad);
		}
	});

	if (visibleAds.length) {
		_visibilityBuffer = invisibleAds;
		_bidCallback(visibleAds);
	}
}

const _checkIfVisibleSoon = debounce(_checkIfVisible, 100);

const LoadVisibleAds = {
	setCallback(callback) {
		_bidCallback = callback;
	},

	showAdsIfVisible(ads) {
		_showAdsIfVisible(ads);
	},

	refreshAdVisibility() {
		_visibilityBuffer = _visibilityBuffer
			.map(_getAdVisibility)
			.filter((ad) => ad);
	},
};

export default LoadVisibleAds;



// WEBPACK FOOTER //
// ./src/shared/modules/onpageads/LoadVisibleAds.js